// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ({"350":"messenger.min","615":"qrcode.min","745":"scanner.min"}[chunkId] + ".js");